import { Box } from '@mui/material'
import React from 'react'
import Cursor from '../Utils/Cursor'

function MyResume() {
  return (
    <Box sx={{width: '100%', height: '100vh'}}>
        <embed
            src="/resume.pdf"
            width="100%"
            height="100%"
            type="application/pdf"
        />
    </Box>
  )
}

export default MyResume